import { useScopeParams } from "@/hooks/useScopeParams";
import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";

type Props = { siteId: string };

export default function SubjectsTab({ siteId }: Props) {
  const { scope, id } = useScopeParams();
  return (
    <MetadataDashboardTemplate
      type="subjects_overview"
      siteId={siteId}
      selectionIdentifierColumn="subject"
      constants={{
        wikiLink: "/wiki/guides/exploration-subjects-overview",
        idLink: (subjectId: string) =>
          `/${scope}/${id}/subjects/overview/${subjectId}/overview`,
      }}
    />
  );
}
